<template>
    <CartCancellationTable
        v-for="item in productCancellation.Items"
        :item="item"
        :key="item.ItemId" />
</template>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';
    import { HotelProduct, ActivityProduct } from '@/api/Cart/cart.interfaces';
    import { getCartProductCancellation } from './CartCancellation.helpers';
    import CartCancellationTable from './CartCancellationTable.vue';
    import { CartProductCancellation } from './CartCancellation.interfaces';

    export default defineComponent({
        name: 'CartCancellation',
        components: {
            CartCancellationTable,
        },
        props: {
            product: {
                type: Object as PropType<HotelProduct | ActivityProduct>,
                required: true,
            },
        },
        setup({ product }) {
            const productCancellation: CartProductCancellation =
                getCartProductCancellation(product); //change to computed

            return {
                productCancellation,
            };
        },
    });
</script>
